import { render, staticRenderFns } from "./setphone.vue?vue&type=template&id=a047475a&scoped=true&"
import script from "./setphone.vue?vue&type=script&lang=js&"
export * from "./setphone.vue?vue&type=script&lang=js&"
import style0 from "./setphone.vue?vue&type=style&index=0&id=a047475a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a047475a",
  null
  
)

export default component.exports